<template>
  <form @submit="register">
    <div class="register">
      <h2 class="register-header">Registration</h2>
      <TextField v-model="email" placeholder="your@email.com" fullWidth>
        <template slot="label"> Email </template>
      </TextField>
      <TextField v-model="username" placeholder="John Snow" fullWidth>
        <template slot="label"> User Name </template>
      </TextField>
      <SelectBox
        v-bind:selected="lang"
        v-bind:onSelect="onLanguageChange"
        v-bind:options="[
          'en',
          'ru',
          'aa',
          'bg',
          'de',
          'es',
          'fi',
          'it',
          'ja',
          'mr',
          'no',
          'pl',
          'ro',
          'se',
          'tr',
          'zh',
          'he',
          'hi',
          'hy'
        ]"
      >
        <template slot="label"> Language </template>
      </SelectBox>

      <TextField
        v-model="pass"
        placeholder="• • • • • • • • •"
        type="password"
        fullWidth
      >
        <template slot="label"> Password </template>
      </TextField>
      <p v-if="error" class="error">Some fields are incorrect</p>
      <Btn
        :onClick="register"
        variant="contained"
        color="primary"
        size="lg"
        class="register-button"
      >
        REGISTER
      </Btn>
      <div>
        Already have an account?
        <router-link class="link login-link" to="/login"> Login </router-link>
      </div>
    </div>
  </form>
</template>

<script>
import TextField from "./TextField";
import Btn from "./Btn";
import SelectBox from "./SelectBox";
import { mapState } from "vuex";

export default {
  components: {
    TextField,
    Btn,
    SelectBox
  },
  data() {
    return {
      email: "",
      pass: "",
      username: "",
      lang: "en"
    };
  },
  computed: mapState("auth", ["error"]),
  methods: {
    onLanguageChange(val) {
      this.lang = val;
    },
    register(e) {
      if (e) {
        e.preventDefault();
      }

      this.$store
        .dispatch("auth/register", {
          email: this.email,
          password: this.pass,
          username: this.username,
          lang: this.lang.toLowerCase(),
          oddsFormat: 'DECIMAL',
          expireIn: 0
        })
        .then(() => this.$router.replace("/sportsbook"));
    }
  }
};
</script>

<style>
.register {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 288px;
  margin: 0 auto;
  padding: 10% 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

.register-header {
  color: #fff;
}

.register-button.register-button {
  margin: 24px 0 16px;
  width: calc(100% - 96px);
}

.error {
  color: red;
}

.login-link {
  margin-left: 4px;
}
</style>
